import { createApp } from 'vue';
import HeicToPngConverter from '../Components/HeicToPngConverter.vue';

const root = document.getElementById('heic-to-png-converter');
if (root) {
  createApp(HeicToPngConverter).mount('#heic-to-png-converter');
}
